var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentPageIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 10,
    viewBox: "0 0 25 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M12.5,0,25,10H0Z",
    transform: "translate(25 10) rotate(180)",
    fill: "#e7ecf0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPageIndicator);
export default __webpack_public_path__ + "static/media/currentPageIndicator.e1639b963ee3133728e3fade01b981ab.svg";
export { ForwardRef as ReactComponent };